export default function Check(props) {
  const style = {
    fill: "#eb2f06",
    ...props.style,
  };

  return (
    <svg
      width={props.size ? props.size : "1em"}
      height={props.size ? props.size : "1em"}
      version="1.1"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className="check"
    >
      <path
        d="m21.469 51.645c-2.1133-2.4727-5.832-2.7617-8.3047-0.64453-2.4727 2.1133-2.7617 5.832-0.64453 8.3047l15.625 18.23 4.4766-3.8281-4.4844 3.8438c2.1211 2.4766 5.8516 2.7617 8.3281 0.64062 0.16406-0.14062 0.32031-0.28906 0.46484-0.44141l52.309-48.684c2.3828-2.2148 2.5156-5.9453 0.30078-8.3281-2.2148-2.3828-5.9453-2.5156-8.3281-0.30078l-48.113 44.777-11.625-13.566z"
        style={style}
      />
    </svg>
  );
}
